(function () {
  var focusClass = "keyboard-focus-visible";
  var keyboardKeys = [
    "Tab",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "End",
    "Home",
    "PageDown",
    "PageUp",
    "Enter",
    " ",
    "Spacebar",
  ];

  function setKeyboardMode() {
    document.documentElement.classList.add("using-keyboard");
  }

  function unsetKeyboardMode() {
    document.documentElement.classList.remove("using-keyboard");
    removeFocusClass(document.activeElement);
  }

  function removeFocusClass(element) {
    if (element && element.classList) {
      element.classList.remove(focusClass);
    }
  }

  function addFocusClass(element) {
    if (
      document.documentElement.classList.contains("using-keyboard") &&
      element &&
      element.classList
    ) {
      element.classList.add(focusClass);
    }
  }

  document.addEventListener(
    "keydown",
    function (event) {
      if (keyboardKeys.indexOf(event.key) !== -1) {
        setKeyboardMode();
        addFocusClass(document.activeElement);
      }
    },
    true
  );

  document.addEventListener("mousedown", unsetKeyboardMode, true);
  document.addEventListener("pointerdown", unsetKeyboardMode, true);
  document.addEventListener("touchstart", unsetKeyboardMode, true);

  document.addEventListener(
    "focusin",
    function (event) {
      addFocusClass(event.target);
    },
    true
  );

  document.addEventListener(
    "focusout",
    function (event) {
      removeFocusClass(event.target);
    },
    true
  );
})();
